import React, { useEffect, useState } from 'react';
import Emoji from './Emoji';
import LessonFile from './LessonFile';
import axios from 'axios';
import { Link } from 'react-router-dom';

const GameLesson = ({ files, changeState, user, defi, points, unlocked, getUser, nbFails }) => {

  const [initd, setInitd] = useState(false);
  const [scores, setScores] = useState();
  const [bon, setBon] = useState(0);
  const [isTrialEnd, setIsTrialEnd] = useState(false);

  // Vérifier si c'est la fin de la version d'essai (défis 12 ou 13)
  useEffect(() => {
    if (defi === 12 || defi === 13 || defi === '12' || defi === '13') {
      setIsTrialEnd(true);
    }
  }, [defi]);

  const endGame = () => {
    changeState();
  }

  const getFailsBonus = () => {
    if (nbFails === 0) {
      return 15;
    }
    else if (nbFails < 5) {
      return nbFails * 2;
    }
    else {
      return 10;
    }
  }

  const resetCheckpoint = () => {
    axios.post('https://connivence-salon.net/api/e-learning/game/post/checkpoint.php', new URLSearchParams({
      user: user.id, checkpoint: 0, points: 0
    })).then(response => {
      console.log("Progression sauvegardée");
    }).catch(error => {
      console.error('Erreur lors de l\'envoi de la requête:', error);
    });
  }

  useEffect(() => {
    console.log(defi);
    if(document.querySelector("header").classList.contains("slides-header")){
      setTimeout(() => {
        document.querySelector("header").classList.remove("slides-header");
      }, 1000);
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    
    // On garde les classes d'origine mais on ajoute une classe spéciale pour le style
    document.body.classList.add("day-mode");
    document.body.classList.add("files-bg");
    if (isTrialEnd) {
      document.body.classList.add("trial-completion");
    }
    
    return () => {
      document.body.classList.remove("day-mode");
      document.body.classList.remove("files-bg");
      document.body.classList.remove("trial-completion");
    }
  }, [defi, isTrialEnd]);

  useEffect(() => {
    // Si c'est la fin de la version d'essai, ne pas continuer avec le calcul normal
    if (isTrialEnd) {
      resetCheckpoint();
      return;
    }
    
    console.log(files);
    resetCheckpoint();

    axios.get('https://connivence-salon.net/api/e-learning/content/achievements.php', {
      params: {
        user: user?.id
      }
    })
      .then(response => {
        if (response.data && response.data.success) {
          setScores(response.data.content);
          axios.get('https://connivence-salon.net/api/e-learning/game/get/success.php', {
            params: {
              defi,
              user: user?.id
            }
          })
            .then(response => {
              if (response.data && response.data.rank) {
                const rank = parseInt(response.data.rank);
                let bn = 0;
                if (rank === 1) {
                  bn = 20;
                  setBon(20);
                }
                else if (rank === 2) {
                  bn = 16;
                  setBon(16);
                }
                else if (rank === 3) {
                  bn = 10;
                  setBon(10);
                }
                else {
                  bn = 0;
                  setBon(0);
                }

                if (initd === false) {
                  axios.post('https://connivence-salon.net/api/e-learning/game/post/endgame.php', new URLSearchParams({
                    user: user.id, defi, points: parseInt(points) + getFailsBonus() + bn
                  })).then(response => {
                    setInitd(true);
                  }).catch(error => {
                    console.error('Erreur lors de l\'envoi de la requête:', error);
                  });
                }
              }
            })
            .catch(error => {
              console.error('Erreur:', error);
            });
        }
      })
      .catch(error => {
        console.error('Erreur:', error);
      });
  }, [user, isTrialEnd]);

  const goToFullVersion = () => {
    window.open("https://connivence-formation.net/e-learning/gestion.php", "_blank");
  }

  return (
    <section className={`game-lesson ${isTrialEnd ? 'trial-complete' : ''}`}>
      {isTrialEnd ? (
        // Version créative avec le fond d'origine
        <>
          {/* Bouton de retour en haut à gauche */}
          <Link to="/home" className="trial-complete__back-link">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M5 12L12 19M5 12L12 5"/>
            </svg>
            Retour à mon espace
          </Link>
          
          <div className="trial-complete__card">
            <div className="trial-complete__sparkles"></div>
            
            <div className="trial-complete__trophy">🏆</div>
            
            <h2 className="trial-complete__title">
              <span className="trial-complete__title-line">Félicitations !</span>
              <span className="trial-complete__title-highlight">Vous avez terminé la version d'essai</span>
            </h2>
            
            <p className="trial-complete__description">
              Poursuivez votre apprentissage et débloquez toutes les fonctionnalités offertes par la version complète !
            </p>
            
            <div className="trial-complete__features">
              <div className="trial-complete__feature">
                <div className="trial-complete__feature-icon">📚</div>
                <div className="trial-complete__feature-text">Des défis hebdomadaires</div>
              </div>
              
              <div className="trial-complete__feature">
                <div className="trial-complete__feature-icon">💡</div>
                <div className="trial-complete__feature-text">Fiches techniques exclusives</div>
              </div>
              
            </div>
            
            <button onClick={goToFullVersion} className="trial-complete__button">
              <span className="trial-complete__button-highlight"></span>
              Acheter un nouvel épisode
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="trial-complete__button-icon">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </>
      ) : (
        // Affichage normal pour les autres défis
        <div className="lesson-intro">
          <Emoji src="files" />
          <p>
            Félicitations ! <strong>Vous avez terminé le défi de la semaine avec succès</strong> 🥳 {defi === 12 || defi === 13 ? "" : "Vous avez donc débloqué de nouvelles fiches de cours."}
          </p>
          <p>
            {defi === 12 || defi === 13 ? <strong className='red'>Dans les prochains défis, vous pourrez télécharger des fiches techniques sur cet écran !</strong> : "Ne partez-pas ! Vous pourrez récolter vos points et améliorer vos récompenses après avoir téléchargé ces fiches..."}
          </p>
          <ul>
            {
              files.map((file, index) =>
                <LessonFile lesson={file} key={index} />
              )
            }
          </ul>
          <button onClick={() => endGame()}>Suivant</button>
        </div>
      )}
    </section>
  );
};

export default GameLesson;